import { endSession } from "./endSession.ts";
import { api } from "./http.ts";

/**
 * Sign this device out of every account and land on the sign-in page.
 *
 * Server first, while the session cookie can still authenticate the call. Then
 * local cleanup regardless: a network error or 5xx must not strand the user in
 * a logged-in-looking UI, and logout has to work offline.
 *
 * A document load rather than a wouter transition: only tearing the document
 * down discards the query cache and the atoms holding this account's drafts.
 */
export async function logout(): Promise<void> {
  try {
    await api.post("/api/a/users/logout");
  } catch {
    // Ignore — the local sign-out below is what actually logs the user out.
  }
  endSession("/auth");
}
